// You can write more code here

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
import { formatErrorForNotification } from '@/common/utils/error';
import { notifyZapier } from '@/common/utils/zapier';
import { getStudent } from '@/game/GameComponents/PhaserGame/GameInstance';
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
/* END-USER-IMPORTS */

export default class VisualAideIcon extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    this.scaleX = 2;
    this.scaleY = 2;

    // backing
    const backing = scene.add.image(0, 0, 'Card_64');
    backing.scaleX = 0.5;
    backing.scaleY = 0.5;
    backing.visible = false;
    this.add(backing);

    // aideIcon
    const aideIcon = scene.add.image(0, 0, 'help3');
    aideIcon.scaleX = 3;
    aideIcon.scaleY = 3;
    this.add(aideIcon);

    this.backing = backing;
    this.aideIcon = aideIcon;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private backing: Phaser.GameObjects.Image;
  private aideIcon: Phaser.GameObjects.Image;

  /* START-USER-CODE */
  iconTexture: string = '';
  targetScale = 0.04;

  getResponsiveElements(key: keyof VisualAideIcon) {
    return ResponsivenessManager.GetAllResponsiveComponentsFromContainer(
      this,
      key,
    );
  }

  setIcon(texture: string) {
    this.iconTexture = texture;
    const key = `${texture}`;
    if (this.scene.textures.exists(key)) {
      this.aideIcon.setTexture(key);
    } else {
      this.setVisible(false);
      notifyZapier({
        hook: 'error',
        userId: getStudent().id,
        organisationId: getStudent().organisationId,
        notifier: 'VisualAideIcon',
        fatal: false,
        error: formatErrorForNotification(
          new Error(`missing icon texture: ${texture}`),
        ),
      });
      return;
    }

    this.backing.setVisible(false);

    // Do reveal feedback.
    this.scene.tweens.add({
      targets: this.aideIcon,
      scale: { from: 0, to: this.targetScale }, // Expands from nothing to full size
      angle: 360, // Rotates 360 degrees
      ease: 'Power2', // Eases out smoothly
      duration: 550, // 1 second duration
    });
    PhaserAudioManager.playSFX(this.scene, 'card-reveal-2');
  }

  doReinforcementFeedback() {
    // Original position to return to
    const originalX = this.x;
    const originalY = this.y;

    // Shake parameters - adjust these to change the feel
    const intensity = 7; // Maximum shake distance
    const duration = 400; // Total duration in ms
    const ease = 'Sine.easeInOut';
    const repeat = 2; // Number of shakes

    // Create the shake tween
    this.scene.tweens.add({
      targets: this,
      x: originalX + intensity,
      duration: duration / (repeat * 2),
      yoyo: true,
      repeat: repeat,
      ease: ease,
      onComplete: () => {
        // Reset to original position when complete
        this.setPosition(originalX, originalY);
      },
      onUpdate: () => {
        // Add some randomness to make it more natural
        if (Math.random() > 0.5) {
          this.x += (Math.random() * intensity) / 4 - intensity / 8;
        }
      },
    });
  }

  getElementSize() {
    return new Phaser.Math.Vector2(
      this.backing.displayWidth,
      this.backing.displayHeight,
    );
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
